module.exports = __webpack_public_path__ + "img/logo1.8b5b03a1.png";